/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container } from 'react-bootstrap';
import Select, { components } from 'react-select';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isEmpty, findIndex, cloneDeep } from 'lodash';
import GreedyMenuTabs from '../../../../Components/GreedyNavBar/TabMenu';
import '../Samples.css';
import Loader from '../../../../Components/Utility/Loader/Loader';
import Annotations from './Annotations/Annotations';
import Specifications from './Specifications/Specifications';
import MissingComponents from './MissingComponents/MissingComponents';
import SupplierAnnotations from './SupplierAnnotations/SupplierAnnotations';
import SupplierSpecification from './SupplierSpecification/SupplierSpecification';
import SampleImages from './SampleImages/SampleImages';
import SupplierImages from './SupplierImages/SupplierImages';
import * as action from '../../store/DevelopmentOrder.action';
import noImage from '../../../../assets/images/no-image.png';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { selectNewStyle, checkArray, SelectNoBorder } from '../../../../Components/helper';
import Comments from './Comments/CommonComment';
import SampleCommentColumn from '../../../../Components/SampleComment/SampleCommentColumn';
import SampleApprovalStatusPill from '../../../../Components/SampleComment/SampleApprovalStatusPill';
import SampleStatusPillShell from '../../../../Components/SampleComment/SampleStatusPillShell';
import { statusSelectMenuStyles } from '../../../../Components/SampleComment/statusSelectMenuStyles';
import { CertificationsIcon, UserFieldsIcon, ChatIcon } from '../../../../bombiix-icon';
import NewBackButton from '../../../../Components/PIM/common/NewBackButton/NewBackButton';
import { fetchProductDetails } from '../../Bom/store/BOMConfig.action';
import FilePreview from '../../../../Components/FilePreview/FilePreview';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import DragDropSort from '../../../../Components/DragDropSort/DragDropSort';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';
import Chat from '../../../Chat/Chat';
import { toIdString, matchOptionToOpenedSample, getSampleBadgeValue } from './sampleDropdownHelpers';

function SampleVersionOptionLabel({ option, tProductSample }) {
  const name = option?.sampleTypeName ?? '';
  let iconClass = 'sample-version-green';
  if (option?.needsApproval && !option?.hasChildSamples) iconClass = 'sample-version-amber';
  let iconTitle = tProductSample('DEVELOPMENT_ORDER.SAMPLES.APPROVED_VERSION');
  if (option?.needsApproval && !option?.hasChildSamples) iconTitle = tProductSample('DEVELOPMENT_ORDER.SAMPLES.NEEDS_APPROVAL');
  else if (option?.isGreen) iconTitle = tProductSample('DEVELOPMENT_ORDER.SAMPLES.AUTO_CREATED_NEXT_STAGE');
  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      <span>{name}</span>
      <span className={`ml-2 sample-version-icon ${iconClass}`} title={iconTitle} aria-label={iconTitle}>
        {getSampleBadgeValue(option)}
      </span>
    </div>
  );
}

function formatSampleVersionOptionLabel(option, tProductSample) {
  return <SampleVersionOptionLabel option={option} tProductSample={tProductSample} />;
}

/* Status color dot helpers for the sample status dropdown */
function StatusDot({ color }) {
  if (!color) return null;
  // eslint-disable-next-line no-nested-ternary
  const bg = color === 'amber' ? 'var(--color-amber)' : color === 'red' ? 'var(--color-red)' : 'var(--color-green)';
  return (
    <span
      style={{
        display: 'inline-block',
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: bg,
        marginRight: 8,
        flexShrink: 0,
      }}
    />
  );
}

function StatusOption(props) {
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <StatusDot color={props.data.statusColor} />
        <span>{props.data.name}</span>
      </div>
    </components.Option>
  );
}

function StatusSingleValue(props) {
  return (
    <components.SingleValue {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>{props.data.name}</span>
      </div>
    </components.SingleValue>
  );
}

function SampleDetails() {
  const { t } = useTranslation('product-sample');
  const formatOptionLabelCb = useCallback((option) => formatSampleVersionOptionLabel(option, t), [t]);
  const childRef = useRef();
  const childRefMissingComp = useRef();
  const childRefSupplierAnnotation = useRef();
  const childRefSpecification = useRef();
  const childRefSupplierSpecification = useRef();
  const childRefSupplierComp = useRef();
  const licensingCommentRef = useRef();
  const customerCommentRef = useRef();
  const containerRef = useRef();

  const dispatch = useDispatch();
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const {
    Measuremets,
    UserDetails,
    BOMConfigDetails: { productDetails, isProductArchived },
  } = devOrderReducer;

  const {
    sampleTabVisible,
    sampleSelectedIdsArray,
    sample_status,
    sampleDetails: sampleDetailsRedux,
    sampleAnnotationImage,
    unreadComments,
    sampleSpecificationReducer,
    sampleTypeGroupsByProduct,
  } = Measuremets;

  const { sampleStatus, supplier, sampleNumber, sampleType, sampleTypeGroupId } = sampleDetailsRedux ?? {};

  const { isSupplierLoggedIn, userInfo } = UserDetails;
  const { gradingFormat } = userInfo;
  const history = useHistory();
  const queryParams = useLocation();
  const { search } = queryParams;
  const smapleId = new URLSearchParams(search).get('sample');
  const { devOrderId, childpath } = useParams();
  const isLicensedProduct = productDetails?.isLicensedProduct ?? false;
  const [viewOnlyCommentColumns, setViewOnlyCommentColumns] = useState({});
  const ProductTestingData = useSelector((redState) => redState);
  const { Users } = ProductTestingData;
  const { logInRights } = Users;
  const [userRights, setUserRights] = useState({});
  const [selectIndex, setSelectIndex] = useState('');
  const [selectedTab, setSelectedTab] = useState('comments');
  const [statusList, setStatusList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [showDragDrop, setShowDragDrop] = useState(false);
  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showStatusConfirm, setShowStatusConfirm] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [sampleTabSwitch, setSampleTabSwitch] = useState('user');
  const [hasUnsavedManualPom, setHasUnsavedManualPom] = useState(false);
  const [state, setState] = useState({
    selectedSampleStatus: null,
    btnDisable: false,
  });
  const [samplesForDropdown, setSamplesForDropdown] = useState([]);
  const [versionsForCurrentSample, setVersionsForCurrentSample] = useState([]);
  const [isViewingPreviousVersion, setIsViewingPreviousVersion] = useState(false);
  const [isLatestWithChildren, setIsLatestWithChildren] = useState(false);
  const [showFilePreviewModal, setFilePreviewModal] = useState(false);
  const [selectedFileToPreview, setFileToPreview] = useState(null);
  const [selectedGradingGroup, setSelectedGradingGroup] = useState({});
  const [sampleImageData, setSampleImageData] = useState([]);
  const [supplierImageData, setSupplierImageData] = useState([]);
  const originalSampleImageDataRef = useRef([]);
  const originalSupplierImageDataRef = useRef([]);
  const [activeUnderline, setActiveUnderline] = useState({});
  const [supplierAccessTabList, setSupplierAccessTabList] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [showSpecPomRearrange, setShowSpecPomRearrange] = useState(false);

  const [switchTabNode, setSwitchTabNode] = useState(null);
  const switchTabRef = (node) => {
    if (node) setSwitchTabNode(node);
  };
  const userSupplierTabs = ['annotateImages', 'sampleSpecification', 'photos'];
  const addButtonTabs = ['steps', 'annotateImages'];
  const uploadButtonTabs = ['photos'];
  const rearrangeButtonTabs = ['photos', 'annotateImages'];
  const deleteButtonTabs = ['steps'];
  const supplierActionAccess = isSupplierLoggedIn ? sampleTabSwitch === 'supplier' : true;
  const [lengthEnabled, setLengthEnabled] = useState(true);

  /**
   * `measureText` falls back to the placeholder when no option is selected yet, to prevent
   * truncation on first render. `width` estimates ~8.5px per char at 14px Aktiv Grotesk,
   * plus 40px for the dropdown indicator and padding.
   */
  const sampleSelectorStyles = useMemo(() => {
    const selected = samplesForDropdown.find((opt) => matchOptionToOpenedSample(opt, sampleDetailsRedux));
    const text = selected?.sampleTypeName ?? '';
    const measureText = text || 'Select sample';
    const width = Math.max(60, Math.ceil(measureText.length * 8.5) + 40);
    return {
      ...SelectNoBorder,
      control: () => ({
        ...SelectNoBorder.control(),
        width,
      }),
      singleValue: (provided) => ({
        ...provided,
        overflow: 'visible',
        maxWidth: 'none',
      }),
    };
  }, [samplesForDropdown, sampleDetailsRedux?._id]);

  const statusSelectStyles = useMemo(() => {
    const selectedId = state.selectedSampleStatus?._id ?? state.selectedSampleStatus;
    const fullStatus =
      statusList.find((status) => status._id?.toString() === selectedId?.toString()) ??
      sample_status?.find((status) => status._id?.toString() === selectedId?.toString());
    const color = fullStatus?.statusColor ?? state.selectedSampleStatus?.statusColor;

    const bg = color === 'amber' ? 'var(--color-amber)' : color === 'red' ? 'var(--color-red)' : color ? 'var(--color-green)' : '#FFF';
    const textColor = color ? 'var(--color-text)' : '#555';
    return {
      ...selectNewStyle,
      control: () => ({
        ...selectNewStyle.control(),
        background: bg,
        border: 'none',
        minHeight: 24,
        height: 24,
        minWidth: 0,
        padding: 0,
        borderRadius: 3,
        boxShadow: 'none',
      }),
      singleValue: (provided, st) => ({
        ...selectNewStyle.singleValue(provided, st),
        color: textColor,
        fontSize: 14,
      }),
      valueContainer: (provided) => ({
        ...selectNewStyle.valueContainer(provided),
        color: textColor,
        padding: '0 8px',
      }),
      indicatorsContainer: () => ({ display: 'none' }),
      indicatorSeparator: () => ({ display: 'none' }),
      ...statusSelectMenuStyles,
    };
  }, [state.selectedSampleStatus, statusList, sample_status]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (userData?.lengthVisible !== null) {
      setLengthEnabled(userData?.lengthVisible);
    }
  }, []);

  const sampleTabAccessRedirect = () => {
    const tabsArray = ['components', 'steps'];
    if (isSupplierLoggedIn && tabsArray.includes(childpath)) {
      history.push('/development-order-overview');
      return false;
    }
  };
  useEffect(() => {
    sampleTabAccessRedirect();
    const el = switchTabNode;

    if (el && sampleTabSwitch) {
      const activeTab = el.querySelector('.active');
      if (activeTab) {
        const tabRect = activeTab.getBoundingClientRect();
        const parentRect = el.getBoundingClientRect();

        setActiveUnderline({
          width: tabRect.width,
          left: tabRect.left - parentRect.left,
        });
      } else {
        setActiveUnderline({
          width: 0,
          display: 'none',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sampleTabSwitch, childpath, switchTabNode]);

  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const { CheckActionPermission } = useComponent();

  useEffect(() => {
    if (sampleAnnotationImage?.sampleImages) {
      setSampleImageData(sampleAnnotationImage?.sampleImages);
      originalSampleImageDataRef.current = cloneDeep(sampleAnnotationImage?.sampleImages);
    }
    if (sampleAnnotationImage?.supplierImages) {
      setSupplierImageData(sampleAnnotationImage?.supplierImages);
      originalSupplierImageDataRef.current = cloneDeep(sampleAnnotationImage?.supplierImages);
    }
  }, [sampleAnnotationImage]);

  useEffect(() => {
    if (!isEmpty(smapleId) && !isEmpty(devOrderId)) {
      setLoader(true);
      setState((prev) => ({ ...prev, selectedSampleStatus: null }));
      const params = {
        devOrderId,
        sampleId: smapleId,
      };
      const callAPI = async () => {
        await Promise.all([
          dispatch(action.getSampleDetail(smapleId, params)),
          dispatch(action.getSampleTabPermission(params)),
          dispatch(action.getSampleSpecificationData(smapleId, { devOrderId })),
          dispatch(action.getSampleAnnotations({ devOrderId, sampleId: smapleId })),
        ]);
      };
      callAPI()
        .then(() => setLoader(false))
        .catch(() => setLoader(false));
    }
  }, [smapleId, devOrderId, dispatch]);

  const hasVersioning = useMemo(() => {
    const isCurrentSample = sampleDetailsRedux && smapleId && toIdString(sampleDetailsRedux) === toIdString(smapleId);
    return isCurrentSample && sampleDetailsRedux?.isNewSample === true && sampleDetailsRedux?.versionNumber != null;
  }, [sampleDetailsRedux, smapleId]);

  useEffect(() => {
    if (!devOrderId) return;
    if (!hasVersioning) {
      setSamplesForDropdown([]);
      return;
    }
    const loadDropdown = async () => {
      const { options, currentSampleHasChild } = await dispatch(action.getSampleDropdownOptions(devOrderId, smapleId));
      setSamplesForDropdown(options);
      // Disable editing if the current sample has a child (was approved and spawned a new version)
      setIsLatestWithChildren(currentSampleHasChild);
    };
    loadDropdown();
  }, [devOrderId, dispatch, hasVersioning, sampleDetailsRedux, smapleId]);

  useEffect(() => {
    if (!devOrderId || !smapleId) {
      setVersionsForCurrentSample([]);
      setIsViewingPreviousVersion(false);
      return;
    }
    if (!hasVersioning) {
      setVersionsForCurrentSample([]);
      setIsViewingPreviousVersion(false);
      return;
    }
    const loadVersionList = async () => {
      const list = await dispatch(action.getSampleVersionList(devOrderId, smapleId));
      const versionList = Array.isArray(list) ? list : [];
      setVersionsForCurrentSample(versionList);
      if (versionList.length > 0) {
        const latest = versionList[versionList.length - 1];
        const notLatest = toIdString(latest) !== toIdString(smapleId);
        setIsViewingPreviousVersion(notLatest);
      } else {
        setIsViewingPreviousVersion(false);
      }
    };
    loadVersionList();
  }, [devOrderId, smapleId, dispatch, hasVersioning]);

  const handleUpdateImageData = async (item, keyName, innerIndex, mainIndex) => {
    const data = [...sampleImageData];
    data[mainIndex][innerIndex][keyName] = item;
    setSampleImageData(data);
  };

  const handleUpdateSupplierImageData = async (item, keyName, innerIndex, mainIndex) => {
    const data = [...supplierImageData];
    data[mainIndex][innerIndex][keyName] = item;
    setSupplierImageData(data);
  };
  const SampleAddEditAccess = CheckActionPermission(userRights, 'products', 'samples', 'addEdit');
  const SampleDeleteAccess = CheckActionPermission(userRights, 'products', 'samples', 'delete');

  // Derived read-only flag: disable editing if viewing a previous version OR if latest version has children
  const isReadOnly = isViewingPreviousVersion || isLatestWithChildren;

  useEffect(() => {
    if (!isEmpty(childpath)) {
      setSelectIndex(childpath);
      setSelectedTab(childpath);
    }
  }, [childpath]);

  useEffect(() => {
    if (!isEmpty(userInfo.userId)) {
      getSampleStatusMaster();
    }
  }, [userInfo.userId]);

  const getSampleStatusMaster = async () => {
    const objUserId = {
      loggedInUserId: userInfo.userId,
      isActive: true,
    };
    dispatch(action.getSampleStatusDetails(objUserId));
  };

  // Fetch sample type groups for status filtering when not already loaded
  useEffect(() => {
    if (sampleTypeGroupsByProduct?.length > 0 || Object.keys(productDetails).length === 0) return;

    const productAttributes = {
      brandId: productDetails?.brandId?._id || productDetails?.brandId || productDetails?.brand?.[0]?._id || productDetails?.brand?._id,
      subBrandId: productDetails?.subBrandId?._id || productDetails?.subBrandId || productDetails?.subBrand?.[0]?._id || productDetails?.subBrand?._id,
      productType: productDetails?.supplierType?._id || productDetails?.supplierType || productDetails?.productType?._id || productDetails?.productType,
      category1: productDetails?.catOneId?._id || productDetails?.catOneId,
      category2: productDetails?.catTwoId?._id || productDetails?.catTwoId,
      category3: productDetails?.catThreeId?._id || productDetails?.catThreeId,
      category4: productDetails?.catFourId?._id || productDetails?.catFourId,
      licensorId: productDetails?.licensorId?._id || productDetails?.licensorId,
      licenseId: productDetails?.licenseId?._id || productDetails?.licenseId,
      likenessId: productDetails?.likenessId?._id || productDetails?.likenessId,
      isLicensedProduct: productDetails?.isLicensedProduct ?? false,
    };

    // eslint-disable-next-line no-unused-vars
    const filteredAttributes = Object.fromEntries(Object.entries(productAttributes).filter(([_key, value]) => value != null));

    if (Object.keys(filteredAttributes).length > 0) {
      dispatch(action.getSampleTypeGroupsByProduct(filteredAttributes));
    }
  }, [productDetails, dispatch, sampleTypeGroupsByProduct?.length]);

  const hideShowDragDrop = () => {
    setShowDragDrop(!showDragDrop);
  };
  const handleSaveSequence = async (_e, sequenceList) => {
    const sampleId = sequenceList?.sequence[0]?.sampleId;
    const imageSetOrder = sequenceList?.sequence.map((item) => item._id);
    if (sampleTabSwitch === 'user') {
      await action.saveSampleImageSetsSequence({ sampleId, imageSetOrder }, t);
    } else {
      await action.saveSupplierImageSetSequence({ sampleId, imageSetOrder }, t);
    }

    const paramsSampleImage = {
      devOrderId,
      sampleId,
    };
    await dispatch(action.getSampleAnnotations(paramsSampleImage));
    hideShowDragDrop();
  };

  useEffect(() => {
    if (!sample_status?.length) return;

    const matchingGroup = sampleTypeGroupsByProduct?.find((g) => g._id?.toString() === sampleTypeGroupId?.toString());
    const automationEntry = matchingGroup?.sampleTypeAutomation?.find((a) => a.sampleType?._id?.toString() === sampleType?._id?.toString());

    if (automationEntry?.configuration?.length > 0) {
      const allowedStatusIds = automationEntry.configuration.map((c) => c.onAction?._id?.toString());
      const filtered = sample_status.filter((s) => allowedStatusIds.includes(s._id?.toString()));
      setStatusList(filtered.length > 0 ? filtered : sample_status);
    } else {
      setStatusList(sample_status);
    }
  }, [sample_status, sampleTypeGroupsByProduct, sampleTypeGroupId, sampleType]);

  useEffect(() => {
    dispatch(action.getSampleTraking());
    return () => {
      dispatch(action.unMountSampleDetails());
      dispatch(action.clearSampleTypeGroupsByProduct());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(sampleTabVisible)) {
      const tabsCopy = sampleTabVisible.map((tabEle) => {
        const copy = { ...tabEle };
        delete copy.isSupplierSwitch;
        if (copy.path === 'components' || copy.path === 'steps') {
          copy.visibleToSupplier = false;
          copy.showTab = false;
        } else {
          copy.visibleToSupplier = productDetails?.visibleToSupplier;
          copy.showTab = true;
        }
        return copy;
      });
      setMenuList(tabsCopy);
      if (isSupplierLoggedIn && checkArray(tabsCopy) && !isEmpty(smapleId) && !isEmpty(devOrderId)) {
        setSampleTabSwitch('supplier');
        const tabList = tabsCopy.filter((tabEle) => tabEle?.visibleToSupplier === true).map((elem) => elem.path);
        if (tabList?.length > 0) setSupplierAccessTabList(tabList);
      }
    } else {
      setMenuList(sampleTabVisible);
    }
  }, [sampleTabVisible, isSupplierLoggedIn, smapleId, devOrderId]);

  const handleChangeTabSwitch = async (data) => {
    if (isSupplierLoggedIn && data === 'user') {
      if (supplierAccessTabList?.includes(selectedTab)) {
        await saveCurrentTabIfNeeded(sampleTabSwitch);
        setSampleTabSwitch(data);
      } else {
        toasterMsg(t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.ACCESS_DENIED'), 'danger');
      }
    } else {
      await saveCurrentTabIfNeeded(sampleTabSwitch);
      setSampleTabSwitch(data);
    }
  };
  const renderGreedyMenu = () => {
    try {
      return (
        <div className="tab-container d-flex align-items-center pb-16" key={devOrderId}>
          <GreedyMenuTabs
            MenuList={menuList}
            handleChangeSwitch={(e, selectedItem) => handleChangeSwitch(e, selectedItem)}
            selectionTabs={(id) => selectionTabs(id)}
            selectIndex={selectIndex}
            isSupplierLoggedIn={isSupplierLoggedIn}
            unreadCount={unreadComments || 0}
            isProductArchived={isProductArchived}
            fromMeasurements={false}
            selectionAccess={SampleAddEditAccess}
            isSample
            isFullWidth={false}
          />
          {samplesForDropdown?.length > 0 && sampleDetailsRedux?.typeOfSampleType !== 'other' && (
            <div className="sample-version-chips-container">
              {SampleAddEditAccess && (
                <div className="sample-selector-container">
                  <Select
                    options={samplesForDropdown}
                    getOptionLabel={(option) => option.sampleTypeName ?? ''}
                    getOptionValue={(option) => toIdString(option)}
                    name="sampleSelector"
                    value={samplesForDropdown.find((opt) => matchOptionToOpenedSample(opt, sampleDetailsRedux))}
                    onChange={(val) => {
                      if (val?._id) {
                        history.push(`/development-order/${devOrderId}/samples-details/${childpath ?? 'comments'}?sample=${val._id}`);
                      }
                    }}
                    className="common-select"
                    classNamePrefix="common-select"
                    styles={sampleSelectorStyles}
                    placeholder={t('DEVELOPMENT_ORDER.SAMPLES.SAMPLE_DROPDOWN_PLACEHOLDER')}
                    isDisabled={isProductArchived}
                    formatOptionLabel={formatOptionLabelCb}
                  />
                </div>
              )}
              {versionsForCurrentSample.length > 1 && (
                <div className="d-flex align-items-center sample-version-chips">
                  {versionsForCurrentSample.map((v) => {
                    const vid = toIdString(v);
                    const isCurrent = vid === toIdString(smapleId);
                    return (
                      <button
                        key={vid}
                        type="button"
                        className={`btn sample-version-chip ${isCurrent ? 'sample-version-chip-active' : ''}`}
                        onClick={() => {
                          history.push(`/development-order/${devOrderId}/samples-details/${childpath ?? 'comments'}?sample=${vid}`);
                        }}
                        aria-label={t('DEVELOPMENT_ORDER.SAMPLES.VERSION')}
                      >
                        {v.versionNumber ?? ''}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {userSupplierTabs.includes(childpath) && (
            <div className="common-switch-container ml-auto">
              <ul className="new-switch" ref={switchTabRef}>
                <li className={sampleTabSwitch === 'user' && 'active'}>
                  <button type="button" className="switch-item" onClick={() => handleChangeTabSwitch('user')}>
                    User
                  </button>
                </li>
                <li className={sampleTabSwitch === 'supplier' && 'active'}>
                  <button type="button" className="switch-item" onClick={() => handleChangeTabSwitch('supplier')}>
                    Supplier
                  </button>
                </li>
              </ul>
              <div className={`${sampleTabSwitch === 'supplier' && 'active-supplier'} tab-underline`} style={activeUnderline} />
            </div>
          )}
        </div>
      );
    } catch (error) {
      console.error('renderGreedyMenu error:', error);
    }
  };
  const handleChangeSwitch = async (e, selectedItem) => {
    const menuItems = [...sampleTabVisible];
    const findIn = findIndex(menuItems, { _id: selectedItem._id });

    if (findIn >= 0) {
      menuItems[findIn].switch = e.target.checked;
    }
    const obj = menuItems.reduce((acc, cur) => ({ ...acc, [cur._id]: cur.switch }), {});
    const params = {
      devOrderId,
      sampleId: smapleId,
    };
    const data = {
      isVisibleToSupplier: obj,
      sampleType: selectedItem.path,
      sampleSwitches: menuItems,
    };

    await dispatch(action.setSampleTabPermission(params, data, 'switch', t));
  };

  const canAutoSaveCurrentTab = () => {
    return !isProductArchived && SampleAddEditAccess && supplierActionAccess;
  };

  const hasImageChanges = (currentData, originalData) => {
    if (!currentData || !originalData) return false;
    if (currentData.length !== originalData.length) return false;
    return currentData.some((imageSet, setIndex) => {
      const originalSet = originalData[setIndex];
      if (!originalSet || imageSet.length !== originalSet.length) return false;
      return imageSet.some((item, itemIndex) => {
        const originalItem = originalSet[itemIndex];
        return item?.name !== originalItem?.name || item?.specification?.value !== originalItem?.specification?.value;
      });
    });
  };

  const hasPendingChanges = async (currentTabSwitch = sampleTabSwitch) => {
    try {
      switch (selectedTab) {
        case 'photos': {
          if (currentTabSwitch === 'user') {
            return hasImageChanges(sampleImageData, originalSampleImageDataRef.current);
          }
          return hasImageChanges(supplierImageData, originalSupplierImageDataRef.current);
        }
        case 'annotateImages': {
          if (currentTabSwitch === 'user') {
            return (await childRef.current?.hasPendingChanges?.()) ?? false;
          }
          return (await childRefSupplierAnnotation.current?.hasPendingChanges?.()) ?? false;
        }
        case 'sampleSpecification': {
          if (currentTabSwitch === 'user') {
            return (await childRefSpecification.current?.hasPendingChanges?.()) ?? false;
          }
          return (await childRefSupplierSpecification.current?.hasPendingChanges?.()) ?? false;
        }
        case 'comments': {
          const internalPending = (await childRefSupplierComp.current?.hasPendingChanges?.()) ?? false;
          const licensingPending = licensingCommentRef.current?.hasPendingChanges?.() ?? false;
          const customerPending = customerCommentRef.current?.hasPendingChanges?.() ?? false;
          return internalPending || licensingPending || customerPending;
        }
        case 'steps': {
          return false;
        }
        case 'components': {
          return (await childRefMissingComp.current?.hasPendingChanges?.()) ?? false;
        }
        default:
          return false;
      }
    } catch (e) {
      console.error('hasPendingChanges error:', e);
      return false;
    }
  };

  const saveCurrentTabIfNeeded = async (currentTabSwitch = sampleTabSwitch) => {
    if (!isReadOnly && canAutoSaveCurrentTab()) {
      try {
        const dirty = await hasPendingChanges(currentTabSwitch);
        if (dirty) {
          await onSubmit();
        }
      } catch (error) {
        console.error('saveCurrentTabIfNeeded error:', error);
      }
    }
  };

  const selectionTabs = async (id) => {
    if (isSupplierLoggedIn) setSampleTabSwitch('supplier');
    await saveCurrentTabIfNeeded();
    const selectedTabObj = await sampleTabVisible.filter(({ _id }) => _id === id);
    setSelectIndex(id);
    setSelectedTab(selectedTabObj[0].path);
    await dispatch(action.clearSampleSpecificationReducer());
    if (devOrderId) history.push(`/development-order/${devOrderId}/samples-details/${selectedTabObj[0].path}?sample=${smapleId}`);
  };

  const addBtnClick = () => {
    if (
      selectedTab === 'annotateImages' ||
      selectedTab === 'steps' ||
      selectedTab === 'photos' ||
      selectedTab === 'supplierImages' ||
      selectedTab === 'supplierAnnotations'
    ) {
      setShow(true);
    }
  };
  const onSubmit = async () => {
    let sampleData = null;
    const params = {
      devOrderId,
      section: selectedTab,
      sampleId: smapleId,
      gradingGroup: selectedGradingGroup?.value,
      gradingFormat,
    };
    setState((prevState) => ({ ...prevState, btnDisable: true }));
    switch (selectedTab) {
      case 'comments':
        if (!state.btnDisable) {
          licensingCommentRef?.current?.save?.();
          customerCommentRef?.current?.save?.();
          const res = await childRefSupplierComp?.current?.submitComment();
          if (res) {
            setState((prevState) => ({ ...prevState, btnDisable: false }));
          }
        }
        break;
      case 'annotateImages':
        {
          if (sampleTabSwitch === 'user') {
            sampleData = await childRef.current.getSampleAnnotation();
            const objAnnotation = {
              images: JSON.stringify(sampleData),
              devOrderId,
              sampleId: smapleId,
              title: true,
            };
            await dispatch(action.saveSampleAnnotations(objAnnotation, t));
          } else {
            sampleData = await childRefSupplierAnnotation.current.getSupplierAnnotation();
            const objSSupAnnotation = {
              images: JSON.stringify(sampleData),
              devOrderId,
              sampleId: smapleId,
              isSupplierAnnotation: true,
            };
            await dispatch(action.saveSampleAnnotations(objSSupAnnotation, t));
          }
          await dispatch(action.getSampleAnnotations({ devOrderId, sampleId: smapleId }));
        }

        break;
      case 'sampleSpecification':
        if (sampleTabSwitch === 'user') {
          sampleData = await childRefSpecification.current.getSampleSpecification();
          const indexes = await childRefSpecification.current.getUserChangedIndexes();
          if (indexes?.userChangedIndexes?.length) {
            sampleData.sampleSpecificationList = sampleData.sampleSpecificationList?.map((ele, i) => {
              if (indexes.userChangedIndexes.includes(i)) {
                ele.isUserChanged = true;
              }
              return ele;
            });
          }

          if (!isEmpty(sampleData?.sampleSpecificationList) && sampleData?.selectedGradGroup?.value) {
            sampleData.isCm = sampleData?.selectedGradGroup?.conversationType;
            sampleData.fraction = sampleData?.selectedGradGroup?.fraction;
            sampleData.gradingGroupId = sampleData?.selectedGradGroup?.value;
            await setSampleSpecificationData(sampleData);
            const specificationUpdateParams = {
              sampleId: smapleId,
              gradingGroupId: sampleData?.selectedGradGroup?.value,
            };

            await dispatch(action.getSampleSpecificationByGradingGroup(specificationUpdateParams));
          }
        } else {
          sampleData = await childRefSupplierSpecification.current.getSampleSupplierSpecification();

          let stringifySpecifi = sampleData?.sampleSpecificationList || [];

          if (!sampleData?.selectedGradingGroup?.value) {
            stringifySpecifi = [];
          }

          const groupedBySize = stringifySpecifi.reduce((acc, curr) => {
            const size = curr.sizeName;
            if (!acc[size]) acc[size] = [];
            acc[size].push(curr);
            return acc;
          }, {});

          const multipleSizesData = Object.keys(groupedBySize).map((sizeName) => {
            return {
              sizeName,
              fraction: sampleData?.selectedGradingGroup?.fraction,
              sampleSpecificationData: JSON.stringify(groupedBySize[sizeName]),
            };
          });

          if (multipleSizesData.length > 0) {
            const objPar = {};

            objPar.sampleId = smapleId;
            objPar.conversionType = sampleData.conversionType;
            objPar.supplierId = userInfo.userId;
            objPar.devOrderId = devOrderId;
            objPar.gradingGroupId = sampleData.selectedGradingGroup?.value;

            const objPayloadSpecif = {
              multipleSizesData,
              isCm: sampleData?.selectedGradingGroup?.conversationType?.toLowerCase() === 'cm',
            };
            await dispatch(action.saveSupplierCommentsMulti(smapleId, objPar, objPayloadSpecif, t));

            const supplierSpecificationUpdateParams = {
              sampleId: smapleId,
              gradingGroupId: sampleData?.selectedGradingGroup?.value,
            };
            await dispatch(action.getSampleSpecificationByGradingGroup(supplierSpecificationUpdateParams));
          }
        }
        break;
      case 'photos':
        if (sampleTabSwitch === 'user') {
          await action.updateSampleImages({ sampleId: smapleId, devOrderId, sampleImages: sampleImageData }, t);
        } else {
          await action.updateSupplierImages({ sampleId: smapleId, devOrderId, supplierImages: supplierImageData }, t);
        }
        await dispatch(action.getSampleAnnotations({ devOrderId, sampleId: smapleId }));
        break;

      case 'components':
        sampleData = await childRefMissingComp.current.getSampleMissingComponemt();
        const objMissingComp = {
          libs: sampleData,
          devOrderId,
          isMcComment: true,
          isMissingComponents: true,
        };
        await dispatch(action.saveSampleMissingComp(objMissingComp, t));
        const missingComponentsUpdateParams = {
          supplierId: supplier?._id,
        };
        if (supplier?._id && devOrderId) {
          await dispatch(action.getSampleMissingComponent(devOrderId, missingComponentsUpdateParams));
        }
        break;

      default:
        break;
    }
    setState((prevState) => ({ ...prevState, btnDisable: false }));
  };

  const deleteConfirmation = async () => {
    const { selectedItems } = sampleSelectedIdsArray;
    const isDeleted = await dispatch(action.deleteSamples({ ids: selectedItems, devOrderId }, t));
    if (isDeleted) {
      await dispatch(action.selectedIdsRecordArray({ selectedItems: [], deleted: true }));
      setShowConfirm(false);
    }
  };

  const showDeleteConfirmation = () => {
    const { selectedItems } = sampleSelectedIdsArray;
    if (selectedItems && selectedItems.length > 0) setShowConfirm(true);
    else setShowConfirm(false);
  };

  // fetch product costing list
  useEffect(() => {
    const callFn = async () => {
      dispatch(fetchProductDetails(devOrderId));
    };
    if (!isEmpty(devOrderId)) callFn();
  }, [dispatch, devOrderId]);

  const updateStatus = async (val) => {
    const params = {
      devOrderId,
      section: 'status',
      sampleId: smapleId,
      status: val._id,
    };
    const updatedObj = {
      status: val._id,
    };
    if (updatedObj) await dispatch(action.saveSampleTabData(updatedObj, params));

    setState((prevState) => ({ ...prevState, selectedSampleStatus: val }));
  };

  /* Persists a hardcoded licensing/customer approval status via the section endpoint; the success toast fires from saveSampleTabData's own success branch */
  const updateApprovalStatus = async (field, value) => {
    const savedMessageKey =
      field === 'licensingStatus'
        ? 'DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.LICENSING_STATUS_SAVED'
        : 'DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.CUSTOMER_STATUS_SAVED';
    await dispatch(
      action.saveSampleTabData({ [field]: value }, { devOrderId, section: field, sampleId: smapleId }, undefined, t(savedMessageKey, { ns: 'product-sample' })),
    );
  };

  /* Executes the pending status update after the user confirms the modal */
  const confirmStatusChange = async () => {
    if (isStatusUpdating) return;
    try {
      setIsStatusUpdating(true);
      if (pendingStatusChange?._id) await updateStatus(pendingStatusChange);
    } catch (error) {
      console.error('Failed to update sample status:', error);
      toasterMsg(
        error?.response?.data?.message ||
          error?.message ||
          t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.STATUS_UPDATE_FAILED'),
        'danger',
      );
    } finally {
      setIsStatusUpdating(false);
      setShowStatusConfirm(false);
      setPendingStatusChange(null);
    }
  };

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      selectedSampleStatus: sampleStatus ?? null,
    }));
  }, [sampleStatus]);

  const dowloadSamplePreview = async () => {
    const payload = {
      devOrderId,
      selectedModules: JSON.stringify(['sample']),
      supplier: supplier ? supplier._id : '',
      sampleType: JSON.stringify([smapleId]),
      isTechCombined: false,
      tpArray: [],
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      lengthEnabled,
    };

    const openFilePreview = (doc) => {
      const params = {
        fileName: sampleNumber || 'Sample',
        mimeType: 'application/pdf',
        path: doc,
      };
      setFileToPreview(params);
      setFilePreviewModal(true);
    };
    const response = await dispatch(action.orderSubmitAndDownload(payload));
    if (response?.data?.zipUrl?.length > 0) {
      const msg = t(`DEVELOPMENT_ORDER.${response?.message}`);
      toasterMsg(msg, 'success');
      openFilePreview(response?.data?.zipUrl);
    }
    if (response?.data?.blankDetails?.sample) {
      toasterMsg(t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.NO_SAMPLE_ENTRY_FOUND'), 'danger');
    }
  };

  const setSampleSpecificationData = async (sampleData) => {
    let stringifySpecification = null;

    stringifySpecification = (sampleData?.sampleSpecificationList || []).filter((item) => !item.tempId);
    const groupedBySize = (stringifySpecification || []).reduce((acc, curr) => {
      const size = curr.sizeName;
      if (!acc[size]) acc[size] = [];
      acc[size].push(curr);
      return acc;
    }, {});

    const multipleSizesData = Object.keys(groupedBySize).map((sizeName) => {
      return {
        sizeName,
        fraction: sampleData.fraction,
        sampleSpecificationData: JSON.stringify(groupedBySize[sizeName]),
      };
    });

    if (multipleSizesData.length === 0) return;

    const objParams = { devOrderId: '' };
    objParams.devOrderId = devOrderId;
    objParams.conversionType = sampleData.conversationType;
    objParams.sampleId = smapleId;

    if (isSupplierLoggedIn) {
      objParams.supplierId = userInfo.userId;
      objParams.gradingGroupId = sampleData?.selectedGradGroup?.value;
    } else {
      objParams.gradingGroup = sampleData?.selectedGradGroup?.value;
    }

    const objPayloadSpecification = {
      multipleSizesData,
    };

    if (isSupplierLoggedIn) {
      objPayloadSpecification.isCm = sampleData.conversationType !== 'in' && sampleData.conversationType !== 'inch';
      await dispatch(action.saveSupplierCommentsMulti(smapleId, objParams, objPayloadSpecification, t));
    } else {
      await dispatch(action.saveSampleSpecificationMulti(smapleId, objParams, objPayloadSpecification, t));
    }
  };

  const updateSelectedGradinGroup = (val) => {
    setSelectedGradingGroup(val);
  };
  const reArrangeDocPosition = (e) => {
    if (childpath === 'annotateImages') {
      if (sampleTabSwitch !== 'supplier') {
        childRef.current.reArrangeImage(e);
      } else {
        childRefSupplierAnnotation.current.reArrangeImage(e);
      }
    } else {
      e.preventDefault();
      setShowDragDrop(!showDragDrop);
    }
  };

  const sampleList =
    checkArray(sampleImageData) &&
    sampleImageData?.map((ele, i) => {
      ele._id = i;
      ele.sampleId = sampleAnnotationImage?.sampleId;
      return ele;
    });

  const supplierList =
    checkArray(supplierImageData) &&
    supplierImageData?.map((ele, i) => {
      ele._id = i;
      ele.sampleId = sampleAnnotationImage?.sampleId;
      return ele;
    });
  const exportFiles = async () => {
    const params = {
      sampleId: smapleId,
    };

    if (productDetails?.gradingGroups?.length === 1) {
      params.conversationType = productDetails?.gradingGroups[0]?.conversationType;
    }

    if (Array.isArray(sampleSpecificationReducer)) {
      params.gradingGroupId = sampleSpecificationReducer[0].gradingGroup;
      params.sizeName = sampleSpecificationReducer[0].sizeName;
      params.code = sampleSpecificationReducer[0].code;
      params.sampleRef = sampleNumber;
      params.sampleType = sampleType?.name;
      params.productNumber = productDetails?.number;
    }
    await dispatch(action.exportExcel(params));
  };

  const imgSrc = (option) => {
    return option?.image || noImage;
  };

  const currentSampleObject = {
    _id: smapleId,
    sampleNumber,
    supplier: supplier?._id,
    supplierName: supplier?.name,
  };
  const isCommentColumnVisible = (field) => viewOnlyCommentColumns[`${smapleId}-${field}`] ?? Boolean(sampleDetailsRedux?.[field]);
  const toggleCommentColumn = (field) => {
    const nextVisible = !isCommentColumnVisible(field);
    if (isProductArchived || isReadOnly || !SampleAddEditAccess) {
      setViewOnlyCommentColumns((prev) => ({ ...prev, [`${smapleId}-${field}`]: nextVisible }));
      return;
    }
    dispatch(action.saveSampleTabData({ [field]: nextVisible }, { devOrderId, section: field, sampleId: smapleId }, 'tosterOff'));
  };
  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="page-title-filter sticky">
          <div className="title-container d-flex align-items-center">
            <div className="product-image" style={{ backgroundImage: `url(${imgSrc(productDetails)})` }} />
            <h4 className="title d-inline-flex bom-title-list ml-16  w-xs-200px">
              {sampleType?.name}
              {' | '}
              {productDetails?.number}
            </h4>
          </div>
          <div className="search-filter">
            {SampleAddEditAccess && (
              <SampleStatusPillShell icon={<ChatIcon size={20} />} className={`sample-status-pill ${isSupplierLoggedIn ? 'disabled' : ''}`}>
                <Select
                  options={statusList}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  name="samples"
                  value={state.selectedSampleStatus}
                  onChange={(val) => {
                    if (toIdString(val) === toIdString(state.selectedSampleStatus)) return;
                    if (sampleDetailsRedux?.isAutoCreated) {
                      setPendingStatusChange(val);
                      setShowStatusConfirm(true);
                    } else {
                      updateStatus(val);
                    }
                  }}
                  className="sample-status-pill__select"
                  classNamePrefix="sample-approval-status"
                  styles={statusSelectStyles}
                  components={{ Option: StatusOption, SingleValue: StatusSingleValue }}
                  placeholder={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.SELECT_SAMPLE_STATUS')}
                  isDisabled={state?.btnDisable || isProductArchived || isReadOnly}
                />
              </SampleStatusPillShell>
            )}
            {childpath === 'comments' && !isSupplierLoggedIn && isLicensedProduct && (
              <SampleApprovalStatusPill
                icon={<CertificationsIcon size={20} />}
                toggleLabel={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.TOGGLE_LICENSING', { ns: 'product-sample' })}
                expanded={isCommentColumnVisible('showLicensingStatus')}
                onToggle={() => toggleCommentColumn('showLicensingStatus')}
                value={sampleDetailsRedux?.licensingStatus}
                onChange={(value) => updateApprovalStatus('licensingStatus', value)}
                disabled={isProductArchived || !SampleAddEditAccess}
                data-testid="licensing-status-pill"
              />
            )}
            {childpath === 'comments' && !isSupplierLoggedIn && (
              <SampleApprovalStatusPill
                icon={<UserFieldsIcon size={20} />}
                toggleLabel={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.TOGGLE_CUSTOMER', { ns: 'product-sample' })}
                expanded={isCommentColumnVisible('showCustomerStatus')}
                onToggle={() => toggleCommentColumn('showCustomerStatus')}
                value={sampleDetailsRedux?.customerStatus}
                onChange={(value) => updateApprovalStatus('customerStatus', value)}
                disabled={isProductArchived || !SampleAddEditAccess}
                data-testid="customer-status-pill"
              />
            )}
            <NewBackButton
              className="ml-16 sample-details-back-btn"
              onBack={() => history.push(`/development-order/${devOrderId}/samples`)}
              disabled={isProductArchived}
              data-testid="sample-details-back"
            />
          </div>
          <div className={`${childpath === 'components' && 'component-bottom'} floting-actions`}>
            {!isProductArchived &&
              childpath === 'sampleSpecification' &&
              sampleTabSwitch === 'user' &&
              SampleAddEditAccess &&
              !isReadOnly &&
              !isSupplierLoggedIn && (
                <button aria-label="Add POM" type="button" onClick={() => childRefSpecification.current?.addEmptyPomRow()} className="btn p-0">
                  <i className="icon-Add" />
                </button>
              )}
            {!isProductArchived && selectedTab === 'sampleSpecification' && sampleSpecificationReducer?.length > 0 && !isReadOnly && (
              <button aria-label="Add" type="button" onClick={() => exportFiles()} className="btn p-0">
                <i className="icon-Export-Excel" />
              </button>
            )}
            {!isProductArchived && addButtonTabs.includes(selectedTab) && supplierActionAccess && !isReadOnly && (
              <button aria-label="Add" type="button" onClick={addBtnClick} className="btn p-0">
                <i className="icon-Add" />
              </button>
            )}
            {!isProductArchived && SampleAddEditAccess && supplierActionAccess && !(childpath === 'comments' && isSupplierLoggedIn) && (
              <button
                aria-label="save"
                className="btn p-0"
                type="button"
                disabled={state.btnDisable || isReadOnly || (childpath === 'sampleSpecification' && sampleTabSwitch === 'user' && hasUnsavedManualPom)}
                onClick={() => onSubmit()}
              >
                <i className="icon-Save-1" />
              </button>
            )}
            {!isProductArchived && uploadButtonTabs.includes(selectedTab) && SampleAddEditAccess && supplierActionAccess && !isReadOnly && (
              <button aria-label="save" className="btn p-0" type="button" onClick={() => addBtnClick()}>
                <i className="icon-Upload-1" />
              </button>
            )}
            {!isProductArchived &&
              rearrangeButtonTabs.includes(selectedTab) &&
              SampleAddEditAccess &&
              supplierActionAccess &&
              !isReadOnly &&
              !(selectedTab === 'photos' && sampleTabSwitch === 'supplier' && !supplierImageData?.some((g) => g?.length)) &&
              !(selectedTab === 'photos' && sampleTabSwitch === 'user' && !sampleImageData?.some((g) => g?.length)) &&
              !(selectedTab === 'annotateImages' && sampleTabSwitch === 'user' && !sampleAnnotationImage?.sampleAnnotateImages?.length) &&
              !(selectedTab === 'annotateImages' && sampleTabSwitch === 'supplier' && !sampleAnnotationImage?.supplierAnnotateImages?.length) && (
                <button aria-label="Rearrange" type="button" className="btn p-0" onClick={reArrangeDocPosition}>
                  <i className="icon-Rearrange" />
                </button>
              )}
            {childpath === 'sampleSpecification' && !isProductArchived && SampleAddEditAccess && supplierActionAccess && !isReadOnly && (
              <button type="button" className="btn p-0 line-normal" onClick={() => setShowSpecPomRearrange(true)} title="Rearrange POM sequence">
                <i className="icon-Rearrange f-24" />
              </button>
            )}
            {!isProductArchived && !isSupplierLoggedIn && (
              <button aria-label="Preview" className="btn p-0" type="button" onClick={() => dowloadSamplePreview()}>
                <i className="icon-PDF-Preview f-22" />
              </button>
            )}
            {!isProductArchived && deleteButtonTabs.includes(selectedTab) && SampleDeleteAccess && (
              <button aria-label="Delete" className="btn p-0" type="button" disabled={state.btnDisable} onClick={() => showDeleteConfirmation()}>
                <i className="icon-Delete f-26" />
              </button>
            )}
          </div>
        </div>

        <div className="sample-details-container mt-4" ref={containerRef}>
          <Container fluid>
            {sampleTabVisible && sampleTabVisible.length > 0 && (
              <React.Fragment key={devOrderId}>
                <div className="new-tab-conatiner" key={devOrderId}>
                  <div className="new-tab-list">{renderGreedyMenu()}</div>
                </div>
              </React.Fragment>
            )}
            {loader ? (
              <Loader />
            ) : (
              <>
                {childpath === 'comments' && (
                  <div className="sample-comments-row">
                    <div className="sample-comments-row__col">
                      <Comments SampleAddEditAccess={SampleAddEditAccess} isViewingPreviousVersion={isReadOnly} ref={childRefSupplierComp} />
                    </div>
                    {!isSupplierLoggedIn && isLicensedProduct && isCommentColumnVisible('showLicensingStatus') && (
                      <div className="sample-comments-row__col">
                        <SampleCommentColumn
                          ref={licensingCommentRef}
                          title={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.LICENSING_TITLE', { ns: 'product-sample' })}
                          field="licensingComment"
                          value={sampleDetailsRedux?.licensingComment ?? ''}
                          sampleId={smapleId}
                          devOrderId={devOrderId}
                          disabled={isProductArchived || isReadOnly || !SampleAddEditAccess}
                          savedMessageKey="DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.LICENSING_SAVED"
                          data-testid="licensing-comment-column"
                        />
                      </div>
                    )}
                    {!isSupplierLoggedIn && isCommentColumnVisible('showCustomerStatus') && (
                      <div className="sample-comments-row__col">
                        <SampleCommentColumn
                          ref={customerCommentRef}
                          title={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.CUSTOMER_TITLE', { ns: 'product-sample' })}
                          field="customerComment"
                          value={sampleDetailsRedux?.customerComment ?? ''}
                          sampleId={smapleId}
                          devOrderId={devOrderId}
                          disabled={isProductArchived || isReadOnly || !SampleAddEditAccess}
                          savedMessageKey="DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.CUSTOMER_SAVED"
                          data-testid="customer-comment-column"
                        />
                      </div>
                    )}
                  </div>
                )}
                {childpath === 'annotateImages' && sampleTabSwitch === 'user' && (
                  <Annotations
                    show={show}
                    selectedTab={selectedTab}
                    toggle={() => setShow(!show)}
                    ref={childRef}
                    SampleDeleteAccess={SampleDeleteAccess}
                    SampleAddEditAccess={SampleAddEditAccess}
                    offsetTop={containerRef?.current?.offsetTop}
                  />
                )}
                {childpath === 'annotateImages' && sampleTabSwitch === 'supplier' && (
                  <SupplierAnnotations
                    show={show}
                    selectedTab={selectedTab}
                    toggle={() => setShow(!show)}
                    hideShowDragDrop
                    ref={childRefSupplierAnnotation}
                    SampleDeleteAccess={SampleDeleteAccess}
                    SampleAddEditAccess={SampleAddEditAccess}
                    offsetTop={containerRef?.current?.offsetTop}
                  />
                )}
                {childpath === 'sampleSpecification' && sampleTabSwitch === 'user' && (
                  <Specifications
                    ref={childRefSpecification}
                    SampleDeleteAccess={SampleDeleteAccess}
                    SampleAddEditAccess={SampleAddEditAccess}
                    selectedGradGroup={selectedGradingGroup}
                    setSelectedGradGroup={updateSelectedGradinGroup}
                    isProductArchived={isProductArchived}
                    devOrderId={devOrderId}
                    showSpecPomRearrange={showSpecPomRearrange}
                    onCloseSpecPomRearrange={() => setShowSpecPomRearrange(false)}
                    onManualPomPendingChange={setHasUnsavedManualPom}
                  />
                )}
                {childpath === 'sampleSpecification' && sampleTabSwitch === 'supplier' && (
                  <SupplierSpecification
                    ref={childRefSupplierSpecification}
                    SampleAddEditAccess={SampleAddEditAccess}
                    isProductArchived={isProductArchived}
                    selectedGradGroupProp={selectedGradingGroup}
                    setSelectedGradGroupProp={updateSelectedGradinGroup}
                    showSpecPomRearrange={showSpecPomRearrange}
                    onCloseSpecPomRearrange={() => setShowSpecPomRearrange(false)}
                  />
                )}
                {childpath === 'photos' && sampleTabSwitch === 'user' && (
                  <SampleImages
                    showDragDrop={showDragDrop}
                    show={show}
                    selectedTab={selectedTab}
                    SampleDeleteAccess={SampleDeleteAccess}
                    toggle={() => setShow(!show)}
                    handleUpdateImageData={handleUpdateImageData}
                    isProductArchived={isProductArchived}
                    isSupplierLoggedIn={isSupplierLoggedIn}
                  />
                )}
                {childpath === 'photos' && sampleTabSwitch === 'supplier' && (
                  <SupplierImages
                    showDragDrop={showDragDrop}
                    show={show}
                    selectedTab={selectedTab}
                    toggle={() => setShow(!show)}
                    SampleDeleteAccess={SampleDeleteAccess}
                    handleUpdateImageData={handleUpdateSupplierImageData}
                  />
                )}

                {childpath === 'components' && <MissingComponents ref={childRefMissingComp} isProductArchived={isProductArchived} />}
              </>
            )}
          </Container>
        </div>
      </form>

      {showConfirm && (
        <ConfirmationPopup
          onOpen={showConfirm}
          onConfirm={() => deleteConfirmation()}
          title={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.DELETE_SAMPLE')}
          message={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.DELETE_MESSAGE')}
          toggle={() => {
            setShowConfirm(false);
          }}
        />
      )}

      {showStatusConfirm && (
        <ConfirmationPopup
          onOpen={showStatusConfirm}
          onConfirm={confirmStatusChange}
          title={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.CHANGE_STATUS_CONFIRM_TITLE')}
          message={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPPLIER_SPECIFICATION.SAMPLE_DETAIL.CHANGE_STATUS_CONFIRM_MESSAGE')}
          disabledBtn={isStatusUpdating}
          toggle={() => {
            if (isStatusUpdating) return;
            setShowStatusConfirm(false);
            setPendingStatusChange(null);
          }}
        />
      )}

      {showFilePreviewModal && (
        <FilePreview onOpen={showFilePreviewModal} fileObj={selectedFileToPreview} toggle={() => setFilePreviewModal(!showFilePreviewModal)} />
      )}

      {showDragDrop && (
        <DragDropSort
          devOrderId={devOrderId}
          itemList={childpath === 'photos' && sampleTabSwitch === 'supplier' ? supplierList : sampleList}
          isShow={showDragDrop}
          isToggle={hideShowDragDrop}
          saveSequence={handleSaveSequence}
          fromComp="sampleImages"
        />
      )}

      <Chat moduleKey="samples" samplesList={[currentSampleObject]} isDetailsPage currentUser={userInfo} />
    </>
  );
}

export default SampleDetails;
